// Draft-relative timing for sold-retention touches. The API stores {days, months}:
// days < 0 = days BEFORE the first draft, days > 0 = days AFTER, months > 0 = months AFTER.

/** @param {{days?: number, months?: number}} o @returns {{direction: 'before'|'after', amount: number, unit: 'days'|'months'}} */
export function toParts(o = {}) {
  const months = Number(o.months) || 0;
  const days = Number(o.days) || 0;
  if (months > 0) return { direction: 'after', amount: months, unit: 'months' };
  if (days < 0) return { direction: 'before', amount: -days, unit: 'days' };
  return { direction: 'after', amount: days, unit: 'days' };
}

/** Inverse of toParts. Months can only be "after" the draft. */
export function fromParts({ direction, amount, unit }) {
  const n = Math.max(0, Math.trunc(Number(amount) || 0));
  if (unit === 'months') return { days: 0, months: n };
  return { days: direction === 'before' ? (-n || 0) : n, months: 0 }; // (-n || 0) avoids a stray -0
}

/** '2 days before draft', 'On the draft day', '5 months after draft'. */
export function describeOffset(o) {
  const { direction, amount, unit } = toParts(o);
  if (!amount) return 'On the draft day';
  const noun = unit === 'months' ? (amount === 1 ? 'month' : 'months') : (amount === 1 ? 'day' : 'days');
  return `${amount} ${noun} ${direction} draft`;
}
